import { Booking } from '@guiker/booking-shared'

export const findApplicationFromBookingById = (booking: Booking, applicantId: string) => {
  return booking.applicants.find((a) => a.userId === applicantId)?.application
}
